###
# This directive can be used to validate or not whether a password input qualifies with
# our minimum password requirements
#
# Example:
#   <input name="password" strong-password>
###
angular.module('rjmNg.directives').directive "strongPassword", [
  () ->
    require: "ngModel",
    restrict: "A"
    link: (scope, elements, attributes, model) ->

      validatorFn = (password) ->
        password?.length >= 8 and password.match(/\d/)? and password.match(/[^A-Za-z0-9 _-]/)?

      model.$validators.strongPassword = validatorFn

]
